import Quickshop from './Quickshop';

export default class ProductListItem {
  constructor({ el }) {
    this.el = el;
    this.el
      .querySelector('.product-list-item-thumbnail')
      .addEventListener('click', event => this.redirectToProduct(event));
    this.productHover = document.querySelector('[data-product-hover]').dataset.productHover;

    if (this.productHover === 'quick-shop') {
      this.quickshop = new Quickshop();
      this.el
        .querySelector('.quick-shop-modal-trigger')
        .addEventListener('click', event => this.openQuickShop(event));
      this.el
        .querySelector('.quick-shop-modal-trigger')
        .addEventListener('mouseover', event => this.preloadQuickshop(event));
    }
  }

  remove() {
    if (this.quickshop) {
      this.quickshop.unload();
      this.el
        .querySelector('.quick-shop-modal-trigger')
        .removeEventListener('click', event => this.openQuickShop(event));
      this.el
        .querySelector('.quick-shop-modal-trigger')
        .removeEventListener('mouseover', event => this.preloadQuickshop(event));
    }
    this.el
      .querySelector('.product-list-item-thumbnail')
      .removeEventListener('click', event => this.redirectToProduct(event));
  }

  redirectToProduct({ target }) {
    const url = !target.classList.contains('quick-shop-modal-trigger') ? target.dataset.url : null;

    if (url) {
      window.location = url;
    }
  }

  openQuickShop(e) {
    const productUrl = e.currentTarget.getAttribute('data-product-url');
    const productSha256 = e.currentTarget.getAttribute('data-product-sha256');
    return this.quickshop.open(productUrl, productSha256);
  }

  preloadQuickshop(e) {
    const productUrl = e.currentTarget.getAttribute('data-product-url');
    const productSha256 = e.currentTarget.getAttribute('data-product-sha256');
    return this.quickshop.load(productUrl, productSha256);
  }
}
